export default __webpack_public_path__ + "static/media/G0070.Expect_child_death_algo_draw_up_GS_april22.1666194000000.a281ce1a.jpg";